/**
 * A global namespace for `focusin` event.
 * @type {string}
 */
const focusinEvent = 'focusin';
export default focusinEvent;
